import React from 'react';

import "bootstrap/dist/css/bootstrap.min.css";
import LoadingSpinner from '../comp/gen/LoadingSpinner';
import UserAuthRequired from '../comp/gen/UserAuthRequired';
import AuthService from '../services/auth-service';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import EcuDiagChart from './EcuDiagChart';
import utils from '../utils';

class Demo2 extends React.Component {
  constructor(props) {    
    super(props)
    this.state = { 
      prova: 1,
      rows: [],
      numRows: 25,
      loaded: false,
    }
  }  
  render() {
    if (!this.props.authStatus.completed) return <LoadingSpinner />
    if (this.props.authStatus.user === null) return <UserAuthRequired notlogged />
    if (!utils.userHasRoleAdmin(this.props.authStatus.user)) return <UserAuthRequired notallowed />
    
    return (
      <>          
        <h2 className="border">DEMO 2</h2>
        <EcuDiagChart
          diag_buffer_id={132}          
        />
      </>
    )
  }
}

export default Demo2;
